import { connect } from 'react-redux'
import { isValidPhoneNumber } from 'react-phone-number-input'
import { fullName, required } from 'util/validation'
import withFormFields from 'shared/ui/Form/withFormFields'
import { selectAccountIsOnboardingCompleted } from 'selectors/app'
import { doSaveAndRedirect } from './actions'

import UserPageView from './view'

const validators = {
  name: fullName,
  phone: val => {
    if (!val || isValidPhoneNumber(val)) return null
    return 'Please enter a valid phone number'
  },
  companyRole: required,
}

const initialValues = {
  name: '',
  phone: '',
  companyRole: null,
}

const select = state => ({
  initialValues,
  validators,
  isOnboardingComplete: selectAccountIsOnboardingCompleted(state),
})

const perform = {
  onSave: doSaveAndRedirect,
}

export default connect(select, perform)(withFormFields(UserPageView))
